import { render } from "./LoadingInner.vue?vue&type=template&id=54ce1f40&scoped=true"
const script = {}

import "./LoadingInner.vue?vue&type=style&index=0&id=54ce1f40&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ce1f40"]])

export default __exports__